const messages = {
  title: "Dobrodošli Bridgestone <span class='text-danger'>PLUS</span>",
  termsAndConditions: "Uslovi i odredbe",
  accept: "Prihvati",
  decline: "Odbij",
  dataModal:
    "Da bismo prilagodili ovu ponudu vašim interesima, molimo vas da ukratko navedete svoje interese za proizvode ili poslovne oblasti.",
  scrollToAccept: "Skrolujte dole da prihvatite naše uslove da biste nastavili",
  welcomeMessage: "Dobrodošli u Bridgestone Plus",
  tailorOffer:
    "Da bismo prilagodili ovu ponudu vašim interesima, molimo vas da ukratko navedete svoje interese za proizvode ili poslovne oblasti.",
  bussinessType:
    "Da bismo prilagodili ovu ponudu vašim interesima, molimo vas da ukratko navedete svoje interese za proizvode ili poslovne oblasti.",
  selectAreas: "Molimo izaberite iz sljedećih oblasti",
  multipleAnswers: "(mogući su višestruki odgovori):",
  personalPreferences: "Lične preferencije",
  carTyres: "Gume za automobile, SUV-ove, komercijalne vozila",
  motorcyclesTyres: "Gume za motocikle",
  truckBusTyres: "Gume za kamione i autobuse",
  agricultureTyres: "Gume za poljoprivredna vozila",
  otrTyres: "OTR gume",
  save: "Sačuvaj",
  businessRelationship: "Kakav je vaš poslovni odnos sa Bridgestone-om?",
  selectRelationship: "Molimo izaberite*:",
  tradingPartner: "Ja sam trgovinski partner koji...",
  tradingPartnerDirect: "... naručuje direktno od Bridgestone-a",
  tradingPartnerIndirect: "... naručuje indirektno (preko veletrgovaca, itd.)",
  tradingPartnerBoth: "... naručuje i direktno i indirektno",
  fleetResponsibleDirect: "Ja sam menadžer flote koji...",
  fleetResponsibleIndirect: "... naručuje indirektno (preko trgovine ili veletrgovine)",
  fleetResponsibleBoth: "... naručuje i direktno i indirektno",
  noBusinessRelationship:
    "<b>Nemam poslovni odnos sa Bridgestone-om</b> (ni direktan ni indirektan)",
  yourCustomerNumber: "Vaš Bridgestone broj kupca*:",
  enterCustomerNumber: "Unesite vaš broj kupca",
  waitPersonalisedView:
    "Molimo sačekajte trenutak, vaš personalizovani pogled na BRIDGESTONE PLUS će biti generisan.",
  personalised: "PERSONALIZOVANO",
  plusInfo:
    "Ovdje možete pronaći informacije o vašem Plus računu i vašoj Plus primljenoj pošti.",
  continue: "Nastavi",
  skip: "Preskoči",
  oneOfTwo: "1 od 2",
  openApps:
    "Možete direktno otvoriti aplikacije za koje ste već registrovan. Također možete zatražiti pristup drugim aplikacijama koje bi vam mogle biti relevantne.",
  requiredFields:
    "Molimo popunite obavezna polja: Titula, Ime, Prezime",
  stage: "Korak",
  chooseOne: "(Molimo označite najmanje 1 kutiju)",
  required: "*obavezna polja",
  lengthCsNumber: "Dužina broja kupca: 6-10 cifara",
  waitForAdminApproval:
    "Hvala vam što ste se prijavili za Bridgestone Plus nagradni program. Trenutno pregledamo vašu prijavu. Primićete email potvrdu kada vaša prijava bude odobrena.",
  selectTyres: "SEKTOR AKTIVNOSTI I PROFIL",
};

export default {
  messages,
};
